export const carouselItems = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20studio%20set%20with%20warm%20dramatic%20lighting%20camera%20equipment%20red%20curtain%20backdrop%20professional%20broadcast%20atmosphere%20modern%20clean%20composition&width=800&height=480&seq=carousel-1&orientation=landscape',
    tag: '深度专题',
    title: '2026暑期档票房大战：谁是最后赢家？',
    desc: '暑期档过半，多部国产大片厮杀正酣。从票房走势、口碑分化到幕后资本博弈，一文看懂今年暑期档的暗流涌动。',
    hot: '9.8万阅读',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20recording%20scene%20colorful%20stage%20lighting%20performers%20in%20motion%20dynamic%20atmosphere%20professional%20production%20set%20warm%20tones&width=800&height=480&seq=carousel-2&orientation=landscape',
    tag: '综艺观察',
    title: '新一季《披荆斩棘》阵容全解析',
    desc: '32位哥哥集结完毕，从老牌唱将到新生代偶像，从演员跨界到专业舞者。我们独家整理了每位选手的背景故事与看点预测。',
    hot: '7.2万阅读',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20film%20set%20behind%20the%20scenes%20director%20chair%20clapperboard%20warm%20cinematic%20lighting%20professional%20movie%20production%20atmosphere%20artistic%20composition&width=800&height=480&seq=carousel-3&orientation=landscape',
    tag: '影视前瞻',
    title: '国庆档预定爆款清单：这五部必看',
    desc: '距离国庆档还有两个月，各大片方已经开始摩拳擦掌。我们根据现有物料和业内口碑，提前为你划重点。',
    hot: '6.5万阅读',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20music%20award%20ceremony%20stage%20warm%20spotlights%20trophy%20red%20carpet%20atmosphere%20glamorous%20event%20professional%20photography&width=800&height=480&seq=carousel-4&orientation=landscape',
    tag: '音乐现场',
    title: '年度音乐盛典幕后：那些你没看到的瞬间',
    desc: '红毯之外、领奖台下的真实故事。歌手们的后台互动、即兴合唱和那些被切掉的感言，我们全部记录。',
    hot: '5.1万阅读',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20celebrity%20couple%20romantic%20scene%20warm%20golden%20hour%20lighting%20elegant%20composition%20editorial%20photography%20soft%20atmosphere&width=800&height=480&seq=carousel-5&orientation=landscape',
    tag: '八卦深挖',
    title: '2026上半年明星恋情大盘点',
    desc: '官宣的、被拍的、分手的、复合的——上半年娱乐圈情感动态全纪录，附时间线和关系图谱。',
    hot: '8.3万阅读',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20streaming%20platform%20interface%20modern%20design%20entertainment%20content%20display%20warm%20lighting%20digital%20media%20atmosphere%20clean%20composition&width=800&height=480&seq=carousel-6&orientation=landscape',
    tag: '行业趋势',
    title: '短剧赛道大洗牌：谁能活过2026？',
    desc: '短剧市场从野蛮生长进入精耕细作阶段。平台政策收紧、制作成本攀升，我们梳理了最新的行业格局变化。',
    hot: '4.7万阅读',
  },
];